export const utils = {

  formatDataBR: function(isoString) {

    const data = new Date(isoString);
    const dia = data.getDate().toString().padStart(2, '0');
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const ano = data.getFullYear();
    const hora = data.getHours().toString().padStart(2, '0');
    const minuto = data.getMinutes().toString().padStart(2, '0');
    
    return `${dia}/${mes}/${ano} ${hora}:${minuto}`;

  },

  getExtensionFromMimeType: function (mimeType) {

    if (!mimeType) {
        return 'bin';
    }

    mimeType = mimeType.toLowerCase().split(';')[0].trim();

    const map = {

        // PDF
        'application/pdf': 'pdf',

        // TEXT
        'text/plain': 'txt',
        'text/html': 'html',
        'text/css': 'css',
        'text/csv': 'csv',
        'text/xml': 'xml',
        'text/javascript': 'js',
        'application/json': 'json',
        'application/xml': 'xml',
        'application/rtf': 'rtf',

        // IMAGES
        'image/jpeg': 'jpg',
        'image/jpg': 'jpg',
        'image/pjpeg': 'jpg',
        'image/jfif': 'jfif',
        'image/pjpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/bmp': 'bmp',
        'image/x-ms-bmp': 'bmp',
        'image/webp': 'webp',
        'image/svg+xml': 'svg',
        'image/tiff': 'tif',
        'image/tif': 'tif',
        'image/x-tiff': 'tif',
        'image/heic': 'heic',
        'image/heif': 'heif',
        'image/vnd.adobe.photoshop': 'psd',
        'image/x-icon': 'ico',
        'image/vnd.microsoft.icon': 'ico',

        // AUDIO
        'audio/mpeg': 'mp3',
        'audio/mp3': 'mp3',
        'audio/wav': 'wav',
        'audio/x-wav': 'wav',
        'audio/ogg': 'ogg',
        'audio/webm': 'webm',
        'audio/aac': 'aac',
        'audio/flac': 'flac',
        'audio/mp4': 'm4a',
        'audio/x-m4a': 'm4a',

        // VIDEO
        'video/mp4': 'mp4',
        'video/mpeg': 'mpeg',
        'video/webm': 'webm',
        'video/quicktime': 'mov',
        'video/x-msvideo': 'avi',
        'video/x-ms-wmv': 'wmv',
        'video/x-flv': 'flv',
        'video/3gpp': '3gp',
        'video/x-matroska': 'mkv',

        // WORD
        'application/msword': 'doc',
        'application/doc': 'doc',
        'application/vnd.ms-word': 'doc',
        'application/vnd.ms-office': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template': 'dotx',
        'application/vnd.ms-word.document.macroenabled.12': 'docm',
        'application/vnd.ms-word.template.macroenabled.12': 'dotm',

        // EXCEL
        'application/vnd.ms-excel': 'xls',
        'application/msexcel': 'xls',
        'application/x-msexcel': 'xls',
        'application/x-ms-excel': 'xls',
        'application/x-excel': 'xls',
        'application/x-dos_ms_excel': 'xls',
        'application/xls': 'xls',
        'application/x-xls': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'xltx',
        'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
        'application/vnd.ms-excel.template.macroenabled.12': 'xltm',
        'application/vnd.ms-excel.addin.macroenabled.12': 'xlam',
        'application/vnd.ms-excel.sheet.binary.macroenabled.12': 'xlsb',
        'text/csv': 'csv',

        // POWERPOINT
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.template': 'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow': 'ppsx',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'pptm',
        'application/vnd.ms-powerpoint.template.macroenabled.12': 'potm',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12': 'ppsm',

        // OPENDOCUMENT
        'application/vnd.oasis.opendocument.text': 'odt',
        'application/vnd.oasis.opendocument.spreadsheet': 'ods',
        'application/vnd.oasis.opendocument.presentation': 'odp',

        // ZIP / COMPRESSED
        'application/zip': 'zip',
        'application/x-zip-compressed': 'zip',
        'application/x-rar-compressed': 'rar',
        'application/vnd.rar': 'rar',
        'application/x-7z-compressed': '7z',
        'application/gzip': 'gz',
        'application/x-tar': 'tar',

        // E-MAIL
        'message/rfc822': 'eml',
        'application/vnd.ms-outlook': 'msg',

        // EXECUTABLE / BINARY
        'application/octet-stream': 'bin',
        'application/x-msdownload': 'exe',
        'application/x-sh': 'sh',
        'application/x-bat': 'bat',

        // FONT
        'font/ttf': 'ttf',
        'font/otf': 'otf',
        'font/woff': 'woff',
        'font/woff2': 'woff2',

        // EPUB / EBOOK
        'application/epub+zip': 'epub',

        // CAD
        'application/acad': 'dwg',
        'image/vnd.dwg': 'dwg',
        'application/dxf': 'dxf',

        // XML / XSL
        'application/xslt+xml': 'xslt',

        // SQLITE
        'application/vnd.sqlite3': 'sqlite',

        // APK
        'application/vnd.android.package-archive': 'apk'
    };

    return map[mimeType] || 'dat';
  },

  getMediaErrorMessage: function (mediaElement) {

    if (!mediaElement || !mediaElement.error) {
        return 'Não foi possível carregar o arquivo de mídia.';
    }

    switch (mediaElement.error.code) {

        case MediaError.MEDIA_ERR_ABORTED:
            return 'O carregamento do arquivo foi cancelado.';

        case MediaError.MEDIA_ERR_NETWORK:
            return 'Não foi possível acessar o arquivo. O link pode ter expirado ou houve uma falha de rede.';

        case MediaError.MEDIA_ERR_DECODE:
            return 'O arquivo foi carregado, mas não pôde ser processado pelo navegador.';

        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
            return 'O formato do arquivo não é suportado pelo navegador ou o acesso foi negado.';

        default:
            return 'Não foi possível carregar o arquivo de mídia.';
    }
  },

  getMultimidiaMimeTypeByExtensaoLiquidSuite: function (extensaoLiquidSuite) {
  
    switch (parseInt(extensaoLiquidSuite)) {
        case 1:
            return "audio/mpeg";
        case 2:
            return "audio/x-ms-wma";
        case 3:
            return "audio/aac";
        case 4:
            return "audio/wav";
        case 5:
            return "video/avi";
        case 6:
            return "video/quicktime";
        case 8:
            return "video/x-matroska";
        case 9:
            return "video/mp4";
        case 10:
            return "video/x-ms-wmv";
        default:
            return "application/octet-stream";
    }

  },

  getArquivoMimeTypeByExtensaoLiquidSuite: function (extensaoLiquidSuite) {

        switch (parseInt(extensaoLiquidSuite)) {
            case 1:
                return "application/msword"; // DOC

            case 2:
                return "text/plain"; // TXT

            case 3:
                return "application/pdf"; // PDF

            case 4:
                return "application/vnd.ms-excel"; // XLS

            case 5:
                return "application/vnd.ms-powerpoint"; // PPT

            case 6:
                return "application/rtf"; // RTF

            case 7:
                return "application/vnd.ms-outlook"; // MSG

            case 8:
                return "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // DOCX

            case 9:
                return "application/vnd.ms-powerpoint"; // PPS

            case 10:
                return "application/acad"; // DWG

            case 11:
                return "text/html"; // HTM

            case 12:
                return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // XLSX

            case 13:
                return "application/zip"; // ZIP

            case 14:
                return "application/x-7z-compressed"; // 7Z

            case 15:
                return "application/octet-stream"; // BAK

            case 16:
                return "application/vnd.ms-excel.sheet.macroEnabled.12"; // XLSM

            case 17:
                return "application/vnd.openxmlformats-officedocument.presentationml.presentation"; // PPTX

            case 18:
                return "application/octet-stream"; // DAT

            case 19:
                return "text/csv"; // CSV

            case 20:
                return "application/xml"; // XML

            case 21:
                return "application/vnd.ms-xpsdocument"; // XPS

            case 22:
                return "application/vnd.rar"; // RAR

            case 23:
                return "text/html"; // HTML

            case 24:
                return "application/vnd.oasis.opendocument.text"; // ODT

            case 25:
                return "message/rfc822"; // EML

            default:
                return "application/octet-stream";
        }

  },

  isSafariBrowser: function () {

    const userAgent = window.navigator.userAgent;

    const isSafari =
        /Safari/i.test(userAgent) &&
        !/Chrome/i.test(userAgent) &&
        !/Chromium/i.test(userAgent) &&
        !/Android/i.test(userAgent);

    return isSafari;
  },

  isVSCodeElectronBrowser: function () {

    const ua = window.navigator.userAgent || "";

    return ua.includes("Electron") ||
           ua.includes("VSCode") ||
           ua.includes("Code/");
  },

  getPdfJsViewerUrl: function () {

    const ua = window.navigator.userAgent || "";

    const isMobile =
        /Android/i.test(ua) ||
        /iPhone/i.test(ua) ||
        /iPad/i.test(ua) ||
        /iPod/i.test(ua) ||
        /Mobile/i.test(ua);

    const isSafariDesktop =
        /Safari/i.test(ua) &&
        !/Chrome/i.test(ua) &&
        !/Chromium/i.test(ua) &&
        !/Android/i.test(ua) &&
        !/iPhone/i.test(ua) &&
        !/iPad/i.test(ua) &&
        !/iPod/i.test(ua);

    const isEmbeddedBrowser =
        /Electron/i.test(ua) ||
        /VSCode/i.test(ua) ||
        /Code\//i.test(ua);

    if (isMobile || isSafariDesktop || isEmbeddedBrowser) {
        return "/pdfjs-legacy/web/viewer.html";
    }

    return "/pdfjs/web/viewer.html";
  }

};